"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFutureLeverageInfo = exports.useLeverageConfigRow = exports.useLeverageConfig = exports.useFutureLeverage = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const errors_1 = require("../../interface/errors");
const trade_utils_lib_1 = require("trade_utils_lib");
const CustomAssetsProvider_1 = require("../CustomAssetsProvider");
const LeverageConfig_1 = require("./LeverageConfig");
const FutureTradeProcessor_1 = require("../Trade/FutureTrade/FutureTradeProcessor");
const operators_1 = require("rxjs/operators");
const LeverageGetSet_1 = require("./LeverageGetSet");
const FutureAPI_1 = require("../../apis/FutureAPI");
const TriggersApi_1 = require("../../apis/TriggersApi");
var LeverageGetSet_2 = require("./LeverageGetSet");
Object.defineProperty(exports, "useFutureLeverage", { enumerable: true, get: function () { return LeverageGetSet_2.useFutureLeverage; } });
var LeverageConfig_2 = require("./LeverageConfig");
Object.defineProperty(exports, "useLeverageConfig", { enumerable: true, get: function () { return LeverageConfig_2.useLeverageConfig; } });
Object.defineProperty(exports, "useLeverageConfigRow", { enumerable: true, get: function () { return LeverageConfig_2.useLeverageConfigRow; } });
/** 获取更改杠杆倍数所需的提示信息 */
const useFutureLeverageInfo = (props, isFocused) => {
    const { symbolInfo, curLeverage, destLeverage } = props;
    const { position, quoteBalance: balance } = (0, CustomAssetsProvider_1.useFPBalanceInfo)(FutureTradeProcessor_1.FutureAccountType, symbolInfo.base, symbolInfo.quote, isFocused);
    const { maxLeverage, curLeverageRow, leverageError } = (0, LeverageConfig_1.useLeverageConfigRow)(symbolInfo.symbol, destLeverage);
    const [maxNotional, needMargin, marginChanged] = (0, react_1.useMemo)(() => {
        // 当前维持保证金
        const initialMarginD = new trade_utils_lib_1.SafeDecimal(position === null || position === void 0 ? void 0 : position.initialMargin);
        const _needMargin = new trade_utils_lib_1.SafeDecimal(curLeverage).div(new trade_utils_lib_1.SafeDecimal(destLeverage)).mul(initialMarginD);
        return [
            // 最大名义价值
            curLeverageRow === null || curLeverageRow === void 0 ? void 0 : curLeverageRow.notional_limit,
            // 目标杠杆倍数下的当前仓位所需保证金
            _needMargin,
            // 更改杠杆倍数后会增加的保证金
            _needMargin.sub(initialMarginD),
        ];
    }, [curLeverage, curLeverageRow === null || curLeverageRow === void 0 ? void 0 : curLeverageRow.notional_limit, destLeverage, position === null || position === void 0 ? void 0 : position.initialMargin]);
    const changeLeverageAction = (0, react_1.useCallback)((value) => {
        // 需要补充保证金, 并且可用保证金不足
        if (marginChanged.greaterThan(0) && marginChanged.greaterThan(new trade_utils_lib_1.SafeDecimal(balance === null || balance === void 0 ? void 0 : balance.available))) {
            return (0, rxjs_1.throwError)(errors_1.TRADE_CHANGED_LEVERAGED_LOW_MARGIN);
        }
        // 当前仓位价值大于目标杠杆倍数所限制的最大名义价值
        if (new trade_utils_lib_1.SafeDecimal(position === null || position === void 0 ? void 0 : position.positionValue).greaterThan(new trade_utils_lib_1.SafeDecimal(maxNotional))) {
            return (0, rxjs_1.throwError)(errors_1.TRADE_CHANGED_LEVERAGED_HIGH_POSITION_VALUE);
        }
        return (0, rxjs_1.zip)((0, TriggersApi_1.queryActiveTriggers)({
            accountType: FutureTradeProcessor_1.FutureAccountType,
            symbol: symbolInfo.symbol,
            limit: 1,
        }), (0, FutureAPI_1.queryActiveOrders)({
            accountType: FutureTradeProcessor_1.FutureAccountType,
            symbol: symbolInfo.symbol,
            limit: 1,
        })).pipe((0, operators_1.map)(([triggers, orders]) => {
            const length = ((triggers === null || triggers === void 0 ? void 0 : triggers.length) || 0) + ((orders === null || orders === void 0 ? void 0 : orders.length) || 0);
            return length > 0;
        }), (0, operators_1.mergeMap)((res) => {
            if (res) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_CHANGED_LEVERAGED_HAS_ACTIVE_ORDERS);
            }
            return (0, LeverageGetSet_1.updateFutureLeverage)(symbolInfo.symbol, value);
        }));
    }, [balance === null || balance === void 0 ? void 0 : balance.available, marginChanged, maxNotional, position === null || position === void 0 ? void 0 : position.positionValue, symbolInfo.symbol]);
    return {
        maxLeverage: maxLeverage,
        maxNotional: maxNotional,
        needMargin: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(needMargin, symbolInfo.precision),
        marginChanged: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(marginChanged, symbolInfo.precision),
        leverageError: leverageError,
        changeLeverage: changeLeverageAction,
    };
};
exports.useFutureLeverageInfo = useFutureLeverageInfo;
